<ng-container *ngIf="transactions$ | async as transactions">
  <div *ngFor="let day of transactions | keyvalue: keepOrder">
    <h5 class="transaction-date mt-4 mb-3">{{ day.key }}</h5>
    <div class="mb-0 mb-lg-4">
      <div class="transaction-card card my-2 py-2 px-3" *ngFor="let transaction of day.value">
        <div class="transaction-data">
          <div class="text-start transaction-details">
            <div class="fw-bold transaction-text">
              {{ transaction.TransactionDescription || transaction.DescriptionText }}
            </div>

            <div class="transaction-subtext text-white">
              {{ transaction.TransactionDateUTC | UtcToLocaltimePipe: 'hh:mm a' | uppercase }}
            </div>
          </div>
          <div class="text-end">
            <div class="fw-bold font-size-12 text-capitalize">
              {{ transaction.Amount >= 0 ? '+' : ''
              }}{{ transaction.Amount | FortressCurrencyPipe: (transactionType === transactionTypes.loyalty ? 'PTS' : 'USD') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!transactions || !hasTransactions">
    <div class="w-100 text-center no-items pt-4">
      <div class="no-results-placeholder-description card border px-2">
        {{ 'transactions.page.placeholder' | translate }}
      </div>
    </div>
  </ng-container>
</ng-container>
<div *ngIf="loading" class="mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
